import authUrls from '@/views/admin/auth/urls';
import errorUrls from "@/views/admin/errors/urls";
import userUrls from "@/views/admin/users/urls";
import roleUrls from "@/views/admin/roles/urls";
import languageUrls from "@/views/admin/languages/urls";
import officeUrls from "@/views/admin/offices/urls";
import testingUrls from "@/views/admin/testing/urls";
import testingStructureUrls from "@/views/admin/testingStructure/urls";
import questionUrls from "@/views/admin/questions/urls";
import hrmUrls from "@/views/admin/hrm/urls";
import applicationUrls from "@/views/admin/applications/urls";
import stateUrls from "@/views/admin/states/urls";
import positionUrls from "@/views/admin/positions/urls";
import homeUrls from "@/views/admin/Home/urls";
import candidateUrls from "@/views/admin/candidates/urls";
import eventUrls from "@/views/admin/events/urls";
import nrkUrls from "@/views/admin/nrk/urls";
import resourceUrls from "@/views/admin/resources/urls";
import emailUrls from "@/views/admin/email/urls";
import settingsUrl from "@/views/admin/settings/urls";
import reportUrls from "@/views/admin/reports/urls";
import attestationUrls from "@/views/admin/attestation/urls";


//candidate
import candidateAuthUrls from "@/views/candidate/auth/urls";
import candidateTestingUrls from "@/views/candidate/testing/urls";
import mrkUrls from "@/views/admin/mrk/urls";
import demoUrls from "../views/admin/demo/urls";

const urls = {
    auth: authUrls,
    error: errorUrls,
    email: emailUrls,
    user: userUrls,
    role: roleUrls,
    language: languageUrls,
    office: officeUrls,
    testing: testingUrls,
    structure: testingStructureUrls,
    candidateAuth: candidateAuthUrls,
    question: questionUrls,
    hrm: hrmUrls,
    application: applicationUrls,
    state: stateUrls,
    position: positionUrls,
    candidateTesting: candidateTestingUrls,
    event: eventUrls,
    home: homeUrls,
    candidate: candidateUrls,
    nrk: nrkUrls,
    resource: resourceUrls,
    settings: settingsUrl,
    report: reportUrls,
    attestation: attestationUrls,
    mrk: mrkUrls,
    demo: demoUrls
};
export default urls;
